import React from 'react'
import PropTypes from 'prop-types'

import {
  StickyAnchor,
  StickyWrapper,
  StickyMobileChipWrapper,
} from './StickyCSHWrapper.styles'

const StickyCSHWrapper = props => {
  const {
    children,
    hiddenClassName,
    showStickyHeader,
    stickyCSHAnchorId,
    stickyCSHWrapperId,
    isMobileFilterChip,
  } = props

  return (
    <React.Fragment>
      {showStickyHeader ? (
        <React.Fragment>
          <StickyAnchor
            hiddenClassName={hiddenClassName}
            id={stickyCSHAnchorId}
          />
          <StickyWrapper
            isMobileFilterChip={isMobileFilterChip}
            id={stickyCSHWrapperId}
          >
            {children}
          </StickyWrapper>
        </React.Fragment>
      ) : isMobileFilterChip ? (
        <StickyMobileChipWrapper id={'mobileChipStickyWrapper'}>
          {children}
        </StickyMobileChipWrapper>
      ) : (
        children
      )}
    </React.Fragment>
  )
}

StickyCSHWrapper.propTypes = {
  children: PropTypes.node,
  hiddenClassName: PropTypes.string.isRequired,
  stickyCSHAnchorId: PropTypes.string.isRequired,
  stickyCSHWrapperId: PropTypes.string.isRequired,
  showStickyHeader: PropTypes.bool,
  isMobileFilterChip: PropTypes.bool,
}

export { StickyCSHWrapper }
